
import Vue from "vue";

export default Vue.extend({
  name: "DatePickerField",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    extraValidations: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menu: false,
      date: this.value,
    };
  },
  methods: {
    updateValue(value: any) {
      this.$emit("input", value);
    },
  },
  watch: {
    value: function (value) {
      this.date = value;
    },
    date: function (value) {
      this.date = value;
      this.$emit("input", value);
    },
  },
});
